module.exports = __webpack_public_path__ + "assets/img/head_title.21d84147.png";